import { Component, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { powerOfTwoValidator } from 'src/app/shared/validator/power-of-two.validator';
import { MitraNetworkParameters, ModeloDeAtendimento, VerticalBuildingType } from '../../state/network-parameters.model.generated';

@Component({
  selector: 'app-horizontal-collective-units-by-type',
  templateUrl: './horizontal-collective-units-by-type.component.html',
  styleUrls: ['./horizontal-collective-units-by-type.component.scss']
})
export class HorizontalCollectiveUnitsByTypeComponent implements OnInit {

  @Input()
  parameters: MitraNetworkParameters;

  @Input()
  parentForm: FormGroup;

  range = [];

  form: FormGroup;
  typeForm: FormArray;

  constructor(
    private fb: FormBuilder
  ) { }

  ngOnInit(): void {
    this.createForm();
    this.createTypeForms();
    this.range = this.parameters.horizontal_collective_settings.types.map(t => t.min_buildings);
  }

  setMinimum(value: number) {
    if (value > 0) {
      this.createTypes([Number(value)]);
    }
  }

  updateBalancedUnbalancedToggle(index: number, networkType: ModeloDeAtendimento) {
    this.parameters.horizontal_collective_settings.types[index].configuration.network_type = networkType;

    this.typeForm.controls[index].patchValue({ network_type: networkType });
  }

  createTypes(range: number[]) {
    this.range = range;

    this.parameters.horizontal_collective_settings.types = this.range.map((value, i, list) => {
      const min = i > 0 ? value + 1 : value;

      return {
        min_buildings: min,
        max_buildings: list[i + 1] ? list[i + 1] : undefined,
        configuration: {
          splitter_sections: []
        }
      } as VerticalBuildingType;
    });

    this.createTypeForms();
  }

  private createForm(): void {

    let connector: string;

    if (this.parameters.horizontal_collective_settings.fiber_connections === 'With PTO') {
      connector = this.parameters.horizontal_collective_settings.connector_drop_pto;
    } else {
      connector = this.parameters.horizontal_collective_settings.connector_customer_drop_nopto;
    }

    this.form = this.fb.group({
      minimum: ['', Validators.min(1)],
      horizontal_collective_access_per_pon:
        [
          this.parameters.horizontal_collective_access_per_pon,
          [Validators.required, Validators.min(1), Validators.max(128), powerOfTwoValidator()]
        ],
      max_attendance_length_cable:
        [this.parameters.horizontal_collective_settings.max_attendance_length_cable, [Validators.required, Validators.min(0)]],
      connector_box_drop: [this.parameters.horizontal_collective_settings.connector_box_drop, Validators.required],
      fiber_connections: [this.parameters.horizontal_collective_settings.fiber_connections, Validators.required],
      connector: [connector, Validators.required]
    });

    this.parentForm.addControl('vertical', this.form);

    this.form.valueChanges.subscribe(() => this.updateParams());
  }

  private updateParams(): void {
    const { value } = this.form;
    this.parameters.horizontal_collective_access_per_pon = value.horizontal_collective_access_per_pon;

    this.parameters.horizontal_collective_settings = {
      ...this.parameters.horizontal_collective_settings,
      max_attendance_length_cable: Number(value.max_attendance_length_cable),
      connector_box_drop: value.connector_box_drop,
      fiber_connections: value.fiber_connections
    };

    if (this.parameters.horizontal_collective_settings.fiber_connections === 'With PTO') {
      this.parameters.horizontal_collective_settings.connector_drop_pto = value.connector;
      this.parameters.horizontal_collective_settings.connector_customer_drop_nopto = undefined;
    } else {
      this.parameters.horizontal_collective_settings.connector_drop_pto = undefined;
      this.parameters.horizontal_collective_settings.connector_customer_drop_nopto = value.connector;
    }
  }

  private createTypeForms(): void {
    if (this.parentForm.contains('typeForm')) {
      this.parentForm.removeControl('typeForm');
    }
    this.typeForm = this.fb.array([]);
    this.parentForm.addControl('typeForm', this.typeForm);

    this.parameters.horizontal_collective_settings.types.forEach((type) => {
      const group = this.fb.group({
        network_type: [type.configuration.network_type, Validators.required]
      });
      this.typeForm.push(group);

      group.valueChanges.subscribe(values => this.updateType(type, values));
    });
  }

  private updateType(type: VerticalBuildingType, values: any): void {
    type.configuration = {
      ...type.configuration,
      ...values
    };
  }
}
